// 아이 등록, 아이 음성 등록 여부

import { useState, useEffect } from 'react';
import { getRegisterInfo } from '../api/mypage';

export const useRegisterStatus = () => {
  const [registerInfo, setRegisterInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkRegisterStatus = async () => {
      try {
        const rlt = await getRegisterInfo();
        setRegisterInfo(rlt);
      } catch (err) {
        console.error("유저 정보 로드 실패", err);
      } finally {
        setIsLoading(false);
      }
    };
    checkRegisterStatus();
  }, []);

  return { registerInfo, isLoading }; 
};